"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _pointsMall = require("@/api/pointsMall");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
var _productInfo = _interopRequireDefault(require("@/components/productInfo"));
var _batchAudit = _interopRequireDefault(require("@/views/product/batchAudit"));
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _previewBox = _interopRequireDefault(require("@/views/product/previewBox"));
var _product = _interopRequireDefault(require("@/mixins/product"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// 权限判断函数

var objTitle = ['已上架', '未上架'];
var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  keywords: '',
  dateLimit: '',
  isShow: '1'
};
var _default = exports.default = {
  name: 'ProductList',
  components: {
    infoFrom: _productInfo.default
  },
  mixins: [_product.default],
  data: function data() {
    return {
      drawer: false,
      direction: 'rtl',
      headeNum: [],
      timeVal: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      keywords: '',
      checkAll: false,
      isIndeterminate: true,
      componentKey: 0,
      isShow: false,
      productId: 0,
      multipleSelectionAll: [],
      checkedIds: [],
      //选中的id
      loadingBtn: false,
      dialogVisible: false,
      keyNum: 0,
      couponIds: [],
      //优惠券集合
      productInfo: null,
      //商品详情
      productType: 0,
      //商品类型
      isSub: false,
      //佣金设置是否单独设置
      addType: 'isAdd'
    };
  },
  computed: {},
  activated: function activated() {
    this.handleSeachList();
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:integral:product:tabs:headers'])) this.goodHeade();
    if ((0, _permission.checkPermi)(['platform:integral:product:page'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 查看详情
    handleView: function handleView(id) {
      this.productId = id;
      this.isShow = true;
      this.componentKey += 1;
      this.dialogVisibleInfo = true;
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.handleSeachList();
    },
    // 删除成功
    delSuccess: function delSuccess() {
      (0, _public.handleDeleteTable)(this.tableData.data.length, this.tableFrom);
      this.handleSeachList();
    },
    //快速添加
    handleQuickAdd: function handleQuickAdd() {
      var _this = this;
      this.$modalGoodList(function (row) {
        //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
        _this.$router.push({
          path: "/marketing/pointsMall/productManage/creatProduct/".concat(row.id, "/edit/choose")
        });
      }, '');
    },
    //添加商品
    handleAdd: function handleAdd() {
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      this.$router.push({
        path: "/marketing/pointsMall/productManage/creatProduct/0/edit/noChoose"
      });
    },
    //编辑商品
    onEdit: function onEdit(row, copy) {
      var _this2 = this;
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      if (this.tableFrom.type === '1') {
        this.$modalSure('下架该商品吗？出售商品需下架之后可编辑。').then(function () {
          (0, _pointsMall.offShellApi)(row.id).then(function () {
            _this2.$router.push({
              path: "/marketing/pointsMall/productManage/creatProduct/".concat(row.id, "/edit/noChoose/").concat(copy)
            });
          });
        });
      } else {
        this.$router.push({
          path: "/marketing/pointsMall/productManage/creatProduct/".concat(row.id, "/edit/noChoose/").concat(copy)
        });
      }
    },
    handleCloseEdit: function handleCloseEdit() {
      this.drawer = false;
    },
    handleSeachList: function handleSeachList() {
      this.getList(1);
      this.goodHeade();
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.keywords = '';
      this.tableFrom.dateLimit = '';
      this.keywords = '';
      this.timeVal = [];
      this.handleSeachList();
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this3 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      (0, _pointsMall.productHeadersApi)(data).then(function (res) {
        _this3.headeNum = [{
          name: objTitle[0],
          type: '1',
          count: res.upNum
        }, {
          name: objTitle[1],
          type: '0',
          count: res.downNum
        }];
      });
    },
    // 列表
    getList: function getList(num) {
      var _this4 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      (0, _pointsMall.productLstApi)(this.tableFrom).then(function (res) {
        _this4.tableData.data = res.list;
        _this4.tableData.total = res.total;
        _this4.listLoading = false;
      }).catch(function (res) {
        _this4.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    //详情
    handleInfo: function handleInfo(id, type) {
      this.$router.push({
        path: "/product/list/creatProduct/".concat(id, "/2/2/").concat(type)
      });
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this5 = this;
      this.$modalSure("\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u79EF\u5206\u5546\u54C1")).then(function () {
        (0, _pointsMall.productDeleteApi)(id).then(function () {
          _this5.$message.success('删除成功');
          _this5.delSuccess();
        });
      });
    },
    //上下架
    onchangeIsShow: function onchangeIsShow(row) {
      var _this6 = this;
      (0, _pointsMall.putOnShellApi)(row.id).then(function () {
        _this6.$message.success('操作成功');
        _this6.handleSeachList();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    }
  }
};